import { React, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import firebase from "../../node_modules/firebase/compat/app"
import { firebaseConfig } from "../firebase-config";
import { getAuth, deleteUser } from 'firebase/auth';

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Sidebar from './components/sidebar'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { DialogContent, DialogContentText, DialogTitle, Dialog, DialogActions, createTheme, responsiveFontSizes, ThemeProvider } from '@material-ui/core';

let theme = createTheme({
  typography: {
    fontFamily: [
      'Segoe UI', 
      'sans-serif',
    ].join(','),
  }
});

theme = responsiveFontSizes(theme);

firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();

function CloseAccount() {

  const [confirmation, setConfirmation] = useState(false)

  let navigate = useNavigate();

  const closeAcc = async () => {
      const auth = getAuth();
      const user = auth.currentUser;

      deleteUser(user).then(() => {
          console.log("success")
          localStorage.setItem("isAuth", "false");
        }).catch((error) => {
          console.log(error)
        });
      navigate("/");

  }

  const handleConfirm = () => {
    setConfirmation(true);
  }
  
  const handleReject = () => {
    setConfirmation(false);
  }

  const boxStyle = { display:'flex', justifyContent:'center' };
  const cardStyle = { minWidth: 500, padding: "10px 5px", margin: "0 auto", justifyContent:'center' };

  const primaryBtn1 = { mt:1, mb:2, bgcolor: '#7B1113', ":hover": {bgcolor: "#5A0C0E", color: 'white'} };
  const primaryBtn2 = { mt:1, mb:1, bgcolor: '#7B1113', ":hover": {bgcolor: "#5A0C0E", color: 'white'} };
  const secondaryBtn1 = { mt:1, mb:1, color: '#666666', ":hover": {color: '#212121'} };

  return (
    <ThemeProvider theme={theme}>
      <Box>

      {/* SIDEBAR */}
      <Sidebar /> 

      {/* DELETE PROMPT */}
      <Box style={boxStyle}>
        <Grid sx={{mx:5, my:20}}>
          <Card sx={{boxShadow:5, mb:3}} style={cardStyle}>
            <CardContent>
              <Typography align = "center" fontWeight="bold" component="h1" variant="h5" sx={{ mt: 3, mb:5 }}>
                DELETE THIS ACCOUNT?
              </Typography>
              <form>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Button type="submit" variant="contained" sx={primaryBtn1} fullWidth
                    onClick={e => {
                      e.preventDefault()
                      handleConfirm()
                    }}
                    >
                    <b>DELETE</b>
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </CardContent>
          </Card>
        </Grid>
      </Box>  
    </Box>

    {/* CONFIRMATION DIALOGUE */}
    <Dialog open={confirmation} onClose={handleReject} PaperProps={{ sx : { maxWidth: 400} }}>
      <DialogTitle>
        {"Delete Account?"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Deleting this account will permanently remove your access from the admin dashboard.
        </DialogContentText>
      </DialogContent>
      <DialogActions>

        {/* YES BUTTON */}
        <Button type="submit" variant="outlined" size="small" sx={secondaryBtn1}
        onClick={e => {
          e.preventDefault();
          closeAcc()
        }}>Yes, Delete Account</Button>

        {/* NO BUTTON */}
        <Button onClick={handleReject} autoFocus type="submit" variant="contained" size="small" sx={primaryBtn2}>
          No, Keep Account
        </Button>
      </DialogActions>
    </Dialog>
  </ThemeProvider>
  )
}

export default CloseAccount